import { render, staticRenderFns } from "./form-tab-button.vue?vue&type=template&id=c073c79a"
import script from "./form-tab-button.vue?vue&type=script&lang=js"
export * from "./form-tab-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports